/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import Select from '../Select';
import i18next from '../../config/i18next';


const WebformSelect = ({ ...fieldProps }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const title = fieldProps.entity.get('#title');
  const webformKey = fieldProps.entity.get('#webform_key');
  const required = fieldProps.entity.get('#required');
  const options = fieldProps.entity.get('#options');
  const requiredError = fieldProps.entity.get('#required_error');


  const handleChange = (newSelectedOption) => {
    setSelectedOption(newSelectedOption);
    fieldProps.values[webformKey] = newSelectedOption.value;
  };

  if (fieldProps.isValidating === true) {
    if (required && !fieldProps.values[webformKey]) {
      fieldProps.errors[webformKey] = requiredError || 'Required veld';
    }
  }

  const transformedOptions = options.keySeq().map((value, index) => {
    const label = options.get(value);
    return ({ value: value, label: label });
  });

  return (
    <div onClick={() => { fieldProps.touched[webformKey] = true; }}>
      <label htmlFor={webformKey}>{title} {!required && <div className="WebformComponent--optional">{ i18next.t('webform_optional') }</div>}</label>
      {/* @FIXME implement placeholder */}
      <Select
        id={webformKey}
        value={selectedOption}
        handleChange={handleChange}
        options={transformedOptions}
      />
      { fieldProps.errors[webformKey] && fieldProps.touched[webformKey] ? <div className="WebformRadio_error WebformComponent--error">{fieldProps.errors[webformKey]}</div> : null}
    </div>
  );
};

export default WebformSelect;
